import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export const breakdownHeaders: Record<string, EnhancedTableHeader> = {
  BillNumber: {
    name: 'BillNumber',
    title: '#',
    type: EnhancedTableHeaderType.Text,
  },
  DueDate: {
    name: 'DueDate',
    title: 'Due Date',
    type: EnhancedTableHeaderType.Date,
  },
  TotalPremium: {
    name: 'TotalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  AmountDue: {
    name: 'AmountDue',
    title: 'Amount Due',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  AmountReceived: {
    name: 'AmountReceived',
    title: 'Amount Received',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  Commission: {
    name: 'Commission',
    title: 'Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  TaxOnCommission: {
    name: 'TaxOnCommission',
    title: 'Tax On Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  AmountPaid: {
    name: 'AmountPaid',
    title: 'Amount Paid',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  TotalBalance: {
    name: 'TotalBalance',
    title: 'Total Balance',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
};
